import { render, staticRenderFns } from "./BoAbout.vue?vue&type=template&id=056f6c65&"
import script from "./BoAbout.vue?vue&type=script&lang=js&"
export * from "./BoAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports